export function setPostalCode( e ){
    return {
        type: "SET_POSTAL_CODE",
        payload: e
    }
}

export function setStreet( e ){
    return {
        type: "SET_STREET",
        payload: e
    }
}
export function setStreetNumber( e ){
    return {
        type: "SET_STREET_NUMBER",
        payload: e
    }
}

export function setComplement( e ){
    return {
        type: "SET_COMPLEMENT",
        payload: e
    }
}
export function setDistrict( e ){
    return {
        type: "SET_DISTRICT",
        payload: e
    }
}

export function setStateLocation( stateLocation ){
    return {
        type: "SET_STATE_LOCATION",
        payload: stateLocation
    }
}

export function setCityLocation( cityLocation ){
    return {
        type: "SET_CITY_LOCATION",
        payload: cityLocation
    }
}





// WEBPACK FOOTER //
// ./src/components/parts/address-component/actions.js